import {
    PostAPI,
    PostAPIWithoutRequest,
    PostAPIWithoutRequestAndKeyData,
  } from "src/components/api/helper/apiHelper";

  export const SelectProfile = async () => {
    return PostAPIWithoutRequest('User/SelectProfile');
  };
  
  export const UpdateProfile = async (request: string) => {
    return PostAPI(request, 'User/UpdateProfile');
  };
  
  export const ProfileUpload = async (request: string) => {
    return PostAPI(request, 'User/ProfileUpload');
  };

  export const RegisterCustomer = async (request: string) => {
    return PostAPI(request, "User/Registration");
  };

  // export const BranchRegistration = async (request: string) => {
  //   return PostAPI(request, "User/BranchRegistration");
  // };

  // export const SelectGMDropdown = async () =>{
  //   return PostAPIWithoutRequest("User/SelectOnlyGeneralManagerForDropdown");
  // };

  // export const SelectAdvisorDropdown = async () =>{
  //   return PostAPIWithoutRequest("User/SelectOnlyAdvisorForDropdown");
  // };

  // export const SelectBranch = async () =>{
  //   return PostAPIWithoutRequest("User/SelectBranch");
  // };

  export const GenerateOTP = async (request: string) => {
    return PostAPI(request, "Registration/MobileVerificationGenerateOTP");
  };
  
  export const VerifyOTP = async (request: string) => {
    return PostAPI(request, "Registration/MobileVerificationVerifyOTP");
  };
  
  export const TwoFALogin = async (request: string) => {
    return PostAPI(request, "Credential/VerifyTwoFAatLogin");
  };
  
  export const SignIn = async (request: string) => {
    return PostAPI(request, "Credential/Login");
  };
  export const SelectLoginSlider = async() => {
    return PostAPIWithoutRequestAndKeyData('SliderMaster/SelectLoginSlider');
  };

  export const SelectAllUserExceptSuperAdmin = async () => {
    return PostAPIWithoutRequest("User/SelectAllUserExceptSuperAdmin");
  };

  export const SelectAllUserListByCompanyWise = async () => {
    return PostAPIWithoutRequest("User/SelectAllUserListByCompanyWise");
  };

  export const Select_CustomerMobileNumber = async () => {
    return PostAPIWithoutRequest("User/Select_CustomerMobileNumber");
  };

  export const Select_CustomerDetailsForMakeInvoice = async (request: string) => {
    return PostAPI(request, "User/Select_CustomerDetailsForMakeInvoice");
  };


  export const SelectOnlyUserForDropdown = async () => {
    return PostAPIWithoutRequest("User/SelectOnlyUserForDropdown");
  };

  export const Select_EmployeeForReport = async (request: string) => {
    return PostAPI(request, "User/Select_EmployeeForReport");
  };

  